<template>
  <vue-final-modal v-model="state" classes="modal-container" content-class="modal-content">
    <div class="modal__content mt-3 mb-4">

      <!-- Initial Content -->
      <div>
        <p class="text-center" style="font-size: 15px; color:#435666; line-height: 24px; font-weight: 900;">
          Do you want to notify all users in your organisation
          <br>that acceptance of this policy is required?
        </p>
        <div class="modal__action">
          <button @click="onNoOption()" class="btn btn-warning">No</button>
          <button @click="onYesOption()" class="btn btn-primary">Yes</button>
        </div>
      </div>



    </div>
    </vue-final-modal>
</template>

<script>


export default {

  props: {
    dialog: {
      type: Boolean,
      required: true
    },
    policy: {
      type: Object,
      required: true
    }
  },


  data() {
    return {
      state: this.dialog,
      trainingPolicy: {
        id: 0,
        required: false,
      }
    };
  },

  mounted() {
    this.trainingPolicy.id = this.policy.ID
    this.trainingPolicy.required = this.policy.required
  },

  watch: {
    dialog(newVal) {
      this.state = newVal;
    }
  },

  methods: {
    onYesOption(){
      this.state = false;

      this.$emit("onChange", {
        id: this.trainingPolicy.id,
        required: this.trainingPolicy.required,
        notify: true
      });

    },

    onNoOption(){
      this.state = false;

      this.$emit("onChange", {
        id: this.trainingPolicy.id,
        required: this.trainingPolicy.required,
        notify: false
      });
    }

  }

};
</script>



<style scoped>
:deep(.modal-content) {
  max-height: 90%;
  width: 444px !important;
}

.modal__action {
  display: flex;
  justify-content: center;
  gap: 1rem;
  flex-shrink: 0;
  padding: 1rem 0 0;
}

button {
margin-right: 0.5rem;
}

/* policy status tags */
.policy--current {
   color: #00A54F;
}

.policy--review_required {
  color: #F3994D;
}

.policy--review_overdue {
color: #EB1C24;
}

/* override btn designs for modal pop-ups */
.btn-warning {
  border-radius: 10px;
  width: 120px;
  height: 40px;
}
/* override btn designs for modal pop-ups */
.btn-primary {
  border-radius: 10px;
  width: 120px;
  height: 40px;
}

/* override btn designs for modal pop-ups */
.btn-cancel {
  border-radius: 10px;
  width: 120px;
  height: 40px;
}


select>option{
  color: #435666;
  font-size:14px !important;
}

form label:not(#compulsoryLbl){
   color: #00A0C1;
   margin: 0.5rem 0;
}

input:not([type="checkbox"]), select {
   height: 40px;
   border-radius: 10px;
   border: 1px solid #D9D9D9;
   color: #435666;
}

/* Style to hide spinner for number input in Bootstrap 5 */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}

.btn.disabled, .btn:disabled, fieldset:disabled .btn {
	color: white;
	pointer-events: none;
	background-color: #435666;
	border-color: #435666;
	opacity: .5;
}

.btn-square {
  border-radius: 0px;
  border: 1px solid #00A0C1;
}
</style>
